var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "skeleton-wrapper",
    { staticClass: "gfu-hero-banner", attrs: { "has-animation": false } },
    [
      _c(
        "div",
        { staticClass: "gfu-hero-banner__slide is-active _bgc--neutral-950" },
        [
          _c(
            "div",
            { staticClass: "gfu-hero-banner__content gfu-homepage-wrapper" },
            [
              _c(
                "div",
                { staticClass: "gfu-hero-banner__meta" },
                [
                  _c("skeleton-line", {
                    staticClass: "_rounded--common _mb-2",
                    attrs: { height: 12, "width-percent": 30 },
                  }),
                  _vm._v(" "),
                  _c("skeleton-line", { attrs: { height: 30 } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "_mt-2" }, [
                    _c(
                      "div",
                      { staticClass: "_flexcol _gap-1 _mb-1" },
                      [
                        _c("skeleton-line", {
                          attrs: { height: 24, "width-percent": 40 },
                        }),
                        _vm._v(" "),
                        _c("skeleton-line", {
                          attrs: { height: 24, "width-percent": 60 },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("nav", { staticClass: "gfu-hero-banner__nav" }, [
        _c("div", { staticClass: "gfu-hero-banner__nav-viewport" }, [
          _c(
            "ul",
            { staticClass: "gfu-hero-banner__nav-track" },
            _vm._l(8, function (item) {
              return _c(
                "li",
                { key: item, staticClass: "gfu-hero-banner__nav-item" },
                [
                  _c("skeleton-button", {
                    staticClass: "gfu-hero-banner__thumb _bd--none",
                    attrs: { height: 50 },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        !_vm.isLessThanL
          ? _c(
              "div",
              { staticClass: "gfu-hero-banner__nav-buttons" },
              [
                _c("skeleton-button", {
                  staticClass: "gfu-btn",
                  attrs: { height: 30 },
                }),
                _vm._v(" "),
                _c("skeleton-button", {
                  staticClass: "gfu-btn",
                  attrs: { height: 30 },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }